module.exports = __webpack_public_path__ + "static/projects-dd166c091135b2af55b4f9668cfc1d50.svg";